import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * Subscription form boolean property values
 * @enum {string}
 */
export const BooleanPropertyValue = {
  FALSE: 'IS_FALSE',
  TRUE: 'IS_TRUE',
  TRUE_OR_FALSE: 'IS_TRUE_OR_FALSE',
};

/**
 * Subscription form property types
 * @enum {string}
 */
export const PropertyType = {
  BOOLEAN: 'BOOLEAN',
  COMBO_BOX: 'COMBO_BOX',
  HIERARCHY: 'HIERARCHY',
  LIST: 'LIST',
  NUMBER: 'NUMBER',
  PASSWORD: 'PASSWORD',
  TEXT: 'TEXT',
  LIST_TEXT_MULTI_SELECT: 'LIST_TEXT_MULTI_SELECT',
  LIST_TEXT_SINGLE_SELECT: 'LIST_TEXT_SINGLE_SELECT',
};

/**
 * Subscription form operator types
 * @enum {string}
 */
export const OperatorTypes = {
  CONTAINS: 'CONTAINS',
  STARTS_WITH: 'STARTS_WITH',
  ENDS_WITH: 'ENDS_WITH',
  IS_ONE_OF: 'IS_ONE_OF',
  IS_ONE_TYPE_OF: 'IS_ONE_TYPE_OF',
  IS_ONE_OR_MORE_OF: 'IS_ONE_OR_MORE_OF',
  MATCHES: 'MATCHES',
};

export const CONTAINS = {
  label: <FormattedMessage id="CONTAINS" />,
  value: OperatorTypes.CONTAINS,
  title: 'Property value contains the specified text',
};

export const STARTS_WITH = {
  label: <FormattedMessage id="STARTS_WITH" />,
  value: OperatorTypes.STARTS_WITH,
  title: 'Detail begins with the specified text or value',
};

export const ENDS_WITH = {
  label: <FormattedMessage id="ENDS_WITH" />,
  value: OperatorTypes.ENDS_WITH,
  title: 'Detail ends with the specified text or value',
};

export const IS_ONE_OF = {
  label: <FormattedMessage id="IS_ONE_OF" />,
  value: OperatorTypes.IS_ONE_OF,
  title: 'Message includes any of the selected values',
};

export const IS_ONE_TYPE_OF = {
  label: <FormattedMessage id="IS_ONE_TYPE_OF" />,
  value: OperatorTypes.IS_ONE_TYPE_OF,
  title: 'Message includes any value from the selected branch',
};

export const IS_ONE_OR_MORE_OF = {
  label: <FormattedMessage id="IS_ONE_OR_MORE_OF" />,
  value: OperatorTypes.IS_ONE_OR_MORE_OF,
  title: 'Property matches one or more of the selected values',
};

export const MATCHES = {
  label: <FormattedMessage id="MATCHES" />,
  value: OperatorTypes.MATCHES,
  title: 'Detail exactly matches the specified value',
};

export const DefaultOperators = [CONTAINS, STARTS_WITH, ENDS_WITH];

export const DefaultListOperators = [CONTAINS];
